import { jsx as _jsx } from "react/jsx-runtime";
import { midDay, hourRatio, minuteRatio } from "@bjelos-farm/lib-common-tools";
import { DatePicker, DateTimePicker, TimePicker } from "@material-ui/pickers";
import dayjs from "dayjs";
const offset = dayjs().utcOffset() * minuteRatio;
export const MyTimePicker = ({ label = "Heure", value, onChange, }) => {
    const getEpoch = (value) => {
        if (!value) {
            return midDay;
        }
        return value.hour() * hourRatio + value.minute() * minuteRatio;
    };
    return (_jsx(TimePicker, { label: label, value: dayjs(value - offset), onChange: (value) => onChange(getEpoch(value)) }, void 0));
};
export const MyDatePicker = ({ label = "Date", value, onChange, }) => {
    return (_jsx(DatePicker, { label: label, value: value, onChange: (value) => onChange(value === null || value === void 0 ? void 0 : value.toDate()) }, void 0));
};
export const MyFixedDatePicker = ({ label = "Date", value, onChange, }) => {
    return (_jsx(DatePicker, { variant: "static", label: label, value: value, onChange: (value) => onChange(value === null || value === void 0 ? void 0 : value.toDate()) }, void 0));
};
export const MyDateTimePicker = ({ label = "Date", value, onChange, }) => {
    return (_jsx(DateTimePicker, { DialogProps: { style: { zIndex: 10000 } }, label: label, value: value, onChange: (value) => onChange(value === null || value === void 0 ? void 0 : value.toDate()) }, void 0));
};
//# sourceMappingURL=MyDateTimePicker.js.map